module.exports = __webpack_public_path__ + "img/znxp.ad766c99.gif";